module.exports = __webpack_public_path__ + "static/media/memories.61b0f73c.png";